<template>  
  <iframe loading="lazy" :src="'/video/' + videoId + params" 
    :width="width" 
    :height="height" 
    :frameborder="frameborder" 
    :allowfullscreen="allowfullscreen" 
    :autoplay="autoplay"
    :style="{ aspectRatio: aspectRatio, maxWidth: maxWidth }"
    :muted="mute"
    ></iframe>
</template>

<script setup lang="ts">

interface VideoFrameProps {
  videoId: string,
  autoplay?: string,
  width?: string,
  maxWidth?: string,
  height?: string,
  frameborder?: string,
  allowfullscreen?: string,
  aspectRatio?: string,
  mute?: string,
}

const props = defineProps<VideoFrameProps>()
 
const params = computed(() => {
  return '?autoplay=' + props.autoplay + '&muted=' + props.mute + '&controls=' + props.controls;
})
</script>

<style scoped>

iframe{
  width: 100%;
  height: auto;
}

</style>
